import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62640f06"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "popuBak" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"topTitle\" data-v-62640f06> AD的主要合并症为感染，其中<span class=\"red\" data-v-62640f06>金黄色葡萄球菌</span>定植为最常见的皮肤感染 <div class=\"jiaobiaoThree\" data-v-62640f06>1</div></div><div class=\"boxSwap\" data-v-62640f06><div class=\"boxSwapTwo\" data-v-62640f06><div class=\"topBig\" data-v-62640f06> 细菌感染 <div class=\"jiaobiao\" data-v-62640f06>2</div></div><div class=\"leftbox\" data-v-62640f06><div class=\"leftImg\" data-v-62640f06></div><div class=\"topBigTwo\" data-v-62640f06>特应性皮炎患儿的脓疱疮</div></div><div class=\"rightbox\" data-v-62640f06><div class=\"topBigThree\" data-v-62640f06>感染的症状为</div><div class=\"pointBox\" data-v-62640f06><div class=\"point\" data-v-62640f06>局部红斑</div><div class=\"point\" data-v-62640f06>肿胀</div><div class=\"point\" data-v-62640f06>发热</div><div class=\"point\" data-v-62640f06>压痛</div></div></div></div></div><div class=\"boxSwap\" data-v-62640f06><div class=\"boxSwapTwo\" data-v-62640f06><div class=\"leftbox\" data-v-62640f06><div class=\"leftImgTwo\" data-v-62640f06></div><div class=\"topBigTwo\" data-v-62640f06>疱疹性湿疹</div></div><div class=\"topBig\" data-v-62640f06> 病毒感染 <div class=\"jiaobiao\" data-v-62640f06>2</div></div><div class=\"rightbox\" data-v-62640f06><div class=\"topBigFore\" data-v-62640f06>可表现为</div><div class=\"pointRight\" data-v-62640f06>皮肤瘙痒或疼痛</div><div class=\"pointBoxTwo\" data-v-62640f06><div class=\"topBigFore\" data-v-62640f06>以及出现</div><div class=\"point\" data-v-62640f06>水泡</div><div class=\"pointRight\" data-v-62640f06>穿孔样糜烂</div></div></div></div></div>", 3)
const _hoisted_5 = { class: "boxSwapThree" }
const _hoisted_6 = { class: "boxSwapFore" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "topBigFive" }, [
  /*#__PURE__*/_createTextVNode(" 正常人与AD患者皮肤金黄色葡萄球菌定植率 "),
  /*#__PURE__*/_createElementVNode("div", { class: "jiaobiaoTwo" }, "3")
], -1))
const _hoisted_8 = { class: "circleSwap" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "footDetail" }, [
  /*#__PURE__*/_createElementVNode("span", null, "正常人皮肤表面"),
  /*#__PURE__*/_createElementVNode("span", null, "AD患者皮损处"),
  /*#__PURE__*/_createElementVNode("span", null, "AD急性渗出性皮损")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paper" }, [
  /*#__PURE__*/_createElementVNode("span", null, "1. Sun D, et al. Immunol Allergy Clin North Am. 2017,37(1):75-93."),
  /*#__PURE__*/_createElementVNode("span", null, " 2. Wang V, et al . Ann Allergy Asthma Immunol. 2021 Jan;126(1):3-12."),
  /*#__PURE__*/_createElementVNode("span", null, " 3. 郝飞. 临床皮肤科杂志,2002,31(6):402-404.")
], -1))
const _hoisted_11 = { class: "ip" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_van_image, {
              class: "circle",
              width: "4.3467rem",
              height: "1.12rem",
              src: require('../assets/circle.jpg')
            }, null, 8, ["src"])
          ]),
          _hoisted_9,
          _hoisted_10
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_van_image, {
        onClick: $options.nexStep,
        width: "2.5733rem",
        height: "2.5733rem",
        src: require('../assets/jixu.png')
      }, null, 8, ["onClick", "src"]),
      _createVNode(_component_van_image, {
        class: "finger",
        width: "1.28rem",
        height: "1.28rem",
        src: require('../assets/dong.gif')
      }, null, 8, ["src"])
    ])
  ], 64))
}